<template>
  <div class="container my-4">
    <div class="card shadow-lg p-4">
      <!-- Form Header -->
      <h3 class="text-center mb-4">GRN Details Update</h3>

      <!-- Form Section -->
      <div class="form-inline d-flex align-items-center justify-content-between mb-4">
        <!-- Select PO Number -->
        <div class="form-group me-3">
          <label for="poDropdown" class="me-2 fw-bold">Select PO Number</label>
          <select v-model="selectedPo" class="form-control w-auto" id="poDropdown">
         <!--  <option value="" disabled>Select PO</option>-->
            <option v-for="po in poList" :key="po.id" :value="po.id">
              {{ po.refrence_no }}
            </option>
          </select>
        </div>

        <!-- Partial/Complete Dropdown -->
     <!--  <div class="form-group me-3">
          <label for="poDropdown1" class="me-2 fw-bold">Status</label>
          <select v-model="selectedPo1" class="form-control w-auto" id="poDropdown1">
            <option value="0">Partial</option>
            <option value="1">Complete</option>
          </select>
        </div>-->
      </div>

      <!-- Loading Spinner -->
      <div v-if="loading" class="text-center mt-3">
        <i class="fa fa-spinner fa-spin text-primary"></i> Loading...
      </div>

      <!-- GRN Details Table -->
      <div v-if="!loading && gridData.length" class="mt-4">
        <h4 class="mb-3">GRN Details</h4>
        <div class="table-responsive">
          <table class="table table-striped">
            <thead class="table">
              <tr>
                <th scope="col">Item Description</th>
                <th scope="col">Quantity</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in gridData" :key="item.id">
                <td>{{ item.item_name }}</td>
                <td>
                  <input
                    type="number"
                    v-model="item.qty"
                    class="form-control quantity-input"
                    min="0"
                    placeholder="0"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Request Button -->
      <div class="d-flex justify-content-end mt-3">
        <button type="button" class="btn btn-success px-4" @click="updateGrnReq">
          Update GRN
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import { Grnallpolist, fetchGrnDetailsList, updateGrn } from "@/services/dataService";
import { useToast } from "vue-toastification";

export default {
  data() {
    return {
      gridData: [], // Data for the grid
      loading: false, // Loading state
      poList: [], // List of PO numbers
      selectedPo: "", // Selected PO number
      selectedPo1: "0", // Selected status
    };
  },
  methods: {
    async fetchPoNumbers() {
      this.loading = true;
      try {
        const profileId = localStorage.getItem("profile_id");
        const token = localStorage.getItem("token_set");
        const response = await Grnallpolist(profileId, token);
        this.poList = response.data.data; // Adjust based on actual API structure
      } catch (error) {
        console.error("Error fetching PO list:", error);
      } finally {
        this.loading = false;
      }
    },
    // Fetch GRN details based on ID from URL
    async fetchGrnDetails(id) {
      this.loading = true;
      try {
        const token = localStorage.getItem("token_set");
        const response = await fetchGrnDetailsList(id, token);
        if (response.data) {
        //  this.poList = data.poList;
        //  this.selectedPo = data.po_number;
         this.gridData = response.data.grn_details || [];
         this.selectedPo = response.data.purchase_orders_id;
         this.grnID = response.data.grn_id;
         // Set the selected PO number
        }
      } catch (error) {
        console.error("Error fetching GRN details:", error);
      } finally {
        this.loading = false;
      }
    },
    // Save GRN data (currently just a placeholder for future functionality)
    async updateGrnReq() {
      const toast = useToast();

      if (!this.selectedPo) {
        toast.error("Please select a PO number.");
        return;
      }

      const payload = {
        purchase_orders_id: this.selectedPo,
        created_by: parseInt(localStorage.getItem("profile_id"), 10),
        received_date: new Date().toISOString().split("T")[0], // Format: YYYY-MM-DD
        total_value: 0,
      //  grn_status: "", // 0: Partial, 1: Complete
        grn_details: this.gridData.map((item) => ({
          item_id: item.item_id,
          qty: item.qty,
        })),
      };

      try {
        const token = localStorage.getItem("token_set");
        const response = await updateGrn(this.grnID, payload, token);
        toast.success("GRN updated successfully!");
      } catch (error) {
        console.error("Error updating GRN:", error);
        toast.error("Failed to update GRN. Please try again.");
      }
    },
  },
  mounted() {
    this.fetchPoNumbers();
    // Extract ID from the URL and fetch details
    const id = this.$route.params.id; // Assumes a Vue Router setup
    if (id) {
      this.fetchGrnDetails(id);
    } else {
      alert("Invalid GRN ID.");
    }
  },
};
</script>

<style scoped>
.card {
  border-radius: 10px;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}

.quantity-input {
  width: 80px;
  text-align: center;
}

button {
  transition: all 0.3s ease-in-out;
}

button:hover {
  transform: scale(1.05);
}

.loading-spinner {
  font-size: 18px;
}
</style>